import { createContext } from 'react'

export const OrgContext = createContext()
export const OrgProvider = OrgContext.Provider

export default OrgContext
